<section class="surcharge-form">
  <p-dialog
    header="Add New Surcharge"
    [dismissableMask]="true"
    [(visible)]="isModalVisible"
    [modal]="true"
    [style]="{ width: '600px' }"
    [draggable]="false"
    [resizable]="false"
    (onHide)="handleModalHide()"
  >
    <form [formGroup]="surchargeForm">
      <app-input-field
        [form]="surchargeForm"
        controlName="surcharge"
        label="Surcharge"
        placeholder="Enter Surcharge Name"
      ></app-input-field>
      <div class="form-row">
        <app-input-field
          [form]="surchargeForm"
          [type]="InputFieldType.Number"
          controlName="amount"
          label="Amount"
        ></app-input-field>
        <app-input-field
          [form]="surchargeForm"
          [type]="InputFieldType.Number"
          controlName="tax_amount"
          label="Tax Amount"
        ></app-input-field>
      </div>
      <app-input-field
        [form]="surchargeForm"
        [type]="InputFieldType.TextArea"
        controlName="description"
        label="Description"
      ></app-input-field>
      <app-input-field
        [form]="surchargeForm"
        [type]="InputFieldType.Dropdown"
        [options]="typesOptions"
        (onChange)="fetchBrands($event)"
        controlName="type"
        label="Vehicle Type"
        placeholder="Select Type"
      ></app-input-field>
      <div class="form-row">
        <app-input-field
          [form]="surchargeForm"
          [type]="InputFieldType.Dropdown"
          [options]="brandsOptions"
          [optionsLoading]="brandsOptionsLoading"
          (onChange)="fetchModels($event)"
          controlName="brand_id"
          label="Make"
          placeholder="Select Brand"
        ></app-input-field>
        <app-input-field
          [form]="surchargeForm"
          [type]="InputFieldType.Dropdown"
          [options]="modelsOptions"
          [optionsLoading]="modelsOptionsLoading"
          (onChange)="fetchTrims($event)"
          controlName="model_id"
          label="Model"
          placeholder="Select Model"
        ></app-input-field>
      </div>
      <div class="form-row">
        <app-input-field
          [form]="surchargeForm"
          [type]="InputFieldType.Dropdown"
          [options]="trimsOptions"
          [optionsLoading]="trimsOptionsLoading"
          optionLabel="trim"
          controlName="trim_id"
          label="Trim"
          placeholder="Select Trim"
        ></app-input-field>
        <app-input-field
          [form]="surchargeForm"
          [type]="InputFieldType.Dropdown"
          [options]="classesOptions"
          optionLabel="class"
          controlName="vehicle_class_id"
          label="Class"
          placeholder="Select Class"
        ></app-input-field>
      </div>
      <div class="form-row">
        <app-input-field
          [form]="surchargeForm"
          controlName="drive_type"
          label="Drive Type"
        ></app-input-field>
        <app-input-field
          [form]="surchargeForm"
          [type]="InputFieldType.Number"
          controlName="cylinder"
          label="Cylinders"
        ></app-input-field>
      </div>
      <app-input-field
        class="switch"
        [form]="surchargeForm"
        [type]="InputFieldType.Switch"
        controlName="is_active"
        label="Is Active"
      ></app-input-field>
      <app-input-field
        class="switch"
        [form]="surchargeForm"
        [type]="InputFieldType.Switch"
        controlName="is_mandatory"
        label="Is Mandatory"
      ></app-input-field>
    </form>
    <ng-template pTemplate="footer">
      <div class="footer-buttons">
        <button class="cancel-btn" (click)="toggleModal()">Cancel</button>
        <button class="custom-btn" (click)="handleSurchargeSubmit()">
          Commit
        </button>
      </div>
      <button
        *ngIf="!!surchargeToEdit"
        (click)="handleSurchargeDeleting()"
        class="icon-btn delete-btn"
      >
        <img
          src="../../../../assets/images/trash2-fill.svg"
          alt="Delete icon"
        />
        Delete
      </button>
    </ng-template>
  </p-dialog>
</section>
